import { queryOptions } from '@tanstack/react-query';

import { AWAApiV2Service } from '@/services/awa-api-v2';
import { AWAGlobalApiService } from '@/services/global-api/awa-global-api.service';

export const awaUserKeys = {
  all: ['awa-user'] as const,
};

export const awaCurrentSitemateUserKeys = {
  all: ['awa-current-sitemate-user'] as const,
};

export const awaMigrationStatusKeys = {
  all: ['awa-migration-status'] as const,
};

export const awaWorkspaceKeys = {
  all: ['awa-workspace'] as const,
  detail: (workspaceId: string | null | undefined) => [...awaWorkspaceKeys.all, workspaceId] as const,
};

export const awaPublicWorkspaceKeys = {
  all: ['awa-public-workspace'] as const,
  detail: (workspaceId: string | null | undefined) => [...awaPublicWorkspaceKeys.all, workspaceId] as const,
};

export const awaQrCodeKeys = {
  all: ['awa-qr-code'] as const,
  byValue: (qrId: string | undefined, track: boolean) => [...awaQrCodeKeys.all, qrId, track] as const,
};

export const getAWAUserQueryOptions = () => {
  return queryOptions({
    queryKey: awaUserKeys.all,
    queryFn: async () => AWAGlobalApiService.getUser(),
  });
};

export const getAWACurrentSitemateUserQueryOptions = () => {
  return queryOptions({
    queryKey: awaCurrentSitemateUserKeys.all,
    queryFn: async () => (await AWAApiV2Service.GetSitemateUser()).json(),
  });
};

export const getAWAMigrationStatusQueryOptions = () => {
  return queryOptions({
    queryKey: awaMigrationStatusKeys.all,
    queryFn: async () => (await AWAApiV2Service.GetAwaMigrationStatus()).json(),
  });
};

export const getAWAWorkspaceQueryOptions = ({ workspaceId }: { workspaceId: string | null | undefined }) => {
  return queryOptions({
    queryKey: awaWorkspaceKeys.detail(workspaceId),
    queryFn: async () => {
      if (!workspaceId) throw new Error('Workspace ID is required');
      const { workspace } = await (await AWAApiV2Service.GetPublicWorkspaceById(workspaceId)).json();
      return workspace;
    },
    enabled: !!workspaceId,
  });
};

export const getAWAQRCodeQueryOptions = ({ qrId, track = true }: { qrId: string | undefined; track?: boolean }) => {
  return queryOptions({
    queryKey: awaQrCodeKeys.byValue(qrId, track),
    queryFn: async () => {
      if (!qrId) throw new Error('QR ID is required');
      return (await AWAApiV2Service.GetQRCodeByValue({ value: qrId, track })).json();
    },
    enabled: !!qrId,
  });
};
